import { MfeNames } from '@/utils/domains.js';
import { useRequest } from '@/utils/request';

import { cacheKey, query } from '../constants';
import { GetFeatureFlag } from '../utils/getFeatureFlag';
import { getUseFeatureFlagsMethods } from '../utils/getUseFeatureFlagsMethods';

type UseFeatureFlagReturn<Value = boolean | string | null> = {
    getFeatureFlag: ReturnType<GetFeatureFlag<Value>>;
    isLoading: boolean;
    isError: boolean;
};

export type UseFeatureFlags = (params?: { appName?: MfeNames }) => UseFeatureFlagReturn;
export const useFeatureFlags: UseFeatureFlags = (params) => {
    const { appName } = params ?? { appName: process.env.NEXT_PUBLIC_APP_NAME as MfeNames };
    const { data, isLoading, isError } = useRequest({
        cacheKey,
        query,
        appName,
    });

    // Setup
    const { getFeatureFlag } = getUseFeatureFlagsMethods({
        data: data?.featureFlags,
    });

    // Delivery
    return {
        getFeatureFlag,
        isLoading,
        isError,
    };
};
